import { ReactNode, useState } from 'react';

import { Link } from '../Link';
import { Typography } from '../typography';
import { SkipLinksCard, SkipLinksList } from './style';

export interface SkipLinksProps {
    label: ReactNode;
    list: Array<SkipLinkListItemProps>;
}

export interface SkipLinkListItemProps {
    link: string;
    text: ReactNode;
}

enum FocusTypeProps {
    blur = 'blur',
    focus = 'focus',
}

export const SkipLinks = ({ label, list, ...other }: SkipLinksProps) => {
    const [showSkipLinks, setShowSkipLinks] = useState(false);

    const detectFocus = (e: React.FocusEvent<HTMLDivElement>) => {
        if (!e.currentTarget.contains(e.relatedTarget as HTMLElement)) {
            if (e.type === FocusTypeProps.blur) {
                setShowSkipLinks(false);
            }

            if (e.type === FocusTypeProps.focus) {
                setShowSkipLinks(true);
            }
        }
    };

    return (
        <SkipLinksCard
            padding="200"
            onBlur={detectFocus}
            onFocus={detectFocus}
            outline={false}
            showSkipLinks={showSkipLinks}
            {...other}
        >
            <Typography textStyle="bodyMediumStrong" as="div">
                {label}
            </Typography>
            <SkipLinksList>
                {list.map((item) => (
                    <li key={item.link}>
                        <Link href={item.link}>{item.text}</Link>
                    </li>
                ))}
            </SkipLinksList>
        </SkipLinksCard>
    );
};
